<template>
  <a-modal
    :visible="visible"
    :mask-closable="false"
    title="添加回访计划"
    @ok="handleSubmit"
    @cancel="handleCancel"
    @update:visible="handleVisibleChange"
  >
    <a-form ref="formRef" :model="formModel">
      <a-form-item
        field="remind_time"
        label="提醒时间"
        :rules="[{ required: true, message: '请选择提醒时间' }]"
      >
        <a-date-picker
          v-model="formModel.remind_time"
          style="width: 100%"
          placeholder="请选择提醒时间"
          :disabled-date="(current: Date) => dayjs(current).isBefore(dayjs())"
          :show-now-btn="false"
        />
      </a-form-item>
      <a-form-item
        field="content"
        label="提醒内容"
        :rules="[{ required: true, message: '请输入提醒内容' }]"
      >
        <a-textarea
          v-model="formModel.content"
          placeholder="请输入提醒内容"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import dayjs from 'dayjs';
  import { Message } from '@arco-design/web-vue';
  import {
    addFollowUpSchedule,
    AddFollowUpScheduleParams,
  } from '@/api/followup';
  import type { FormInstance } from '@arco-design/web-vue';

  interface Props {
    visible: boolean;
    userId: number;
  }

  interface Emits {
    (e: 'update:visible', value: boolean): void;
    (e: 'success'): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const formRef = ref<FormInstance>();
  const formModel = ref<AddFollowUpScheduleParams>({
    user_id: 0,
    remind_time: '',
    content: '',
  });

  // 监听visible变化，重置表单
  watch(
    () => props.visible,
    (newVal) => {
      if (newVal) {
        formModel.value.user_id = props.userId;
        formModel.value.remind_time = '';
        formModel.value.content = '';
      }
    }
  );

  // 监听userId变化
  watch(
    () => props.userId,
    (newVal) => {
      formModel.value.user_id = newVal;
    }
  );

  const handleSubmit = async () => {
    try {
      await formRef.value?.validate();

      await addFollowUpSchedule(formModel.value);
      Message.success('添加回访计划成功');
      emit('success');
      emit('update:visible', false);
    } catch (error) {
      // 验证失败或API调用失败，不需要额外处理
      // 验证失败时Arco Design会自动显示错误信息
    }
  };

  const handleCancel = () => {
    emit('update:visible', false);
  };

  const handleVisibleChange = (value: boolean) => {
    emit('update:visible', value);
  };
</script>

<style lang="less" scoped>
  :deep(.arco-picker-footer) {
    display: none !important;
  }

  :deep(.arco-picker-today-btn) {
    display: none !important;
  }
</style>
